export default {
  newRequestPath: () => '/requests/new',
  importRequestsWizardPath: () => '/requests/import',
  importRequestsWizardStepPath: (step) => `/requests/import/${step}`,
};
